// extracted by mini-css-extract-plugin
export default {"toggle":"toggle_toggle__tXx1g","slider":"toggle_slider__-v2UG"};